<div *ngIf="pack.isSpecialPack" class="special_label mx-2">
  {{ pack.specialLabel }} *
</div>
<div
  [attr.id]="'pack_' + pack.priceNet"
  class="pack shadow rounded rounded-3 bg-white mx-2"
  [ngClass]="{
    active: pack.selected,
    offre_decouverte: pack.isSpecialPack
  }"
  (click)="selectPack()"
>
  <div class="pack_header">
    <h2>{{ pack.creditTotal }}</h2>
    <strong>crédits</strong>
  </div>

  <hr class="border border-secondary border-2 opacity-100 mx-3" />

  <div class="pack_body">
    <div
      *ngIf="pack.creditFree && pack.creditFree !== 0"
      class="pack_body__credits_offerts"
    >
      dont {{ pack.creditFree }} offerts
    </div>

    <div class="pack_body__price">
      <h4 class="">{{ pack.priceNet }}&nbsp;€ HT</h4>
      <div class="pack_body__price__ttc">
        ({{ pack.priceGross | currency: "EUR" : "symbol" : "1.2-2" }} TTC)
      </div>
    </div>
  </div>
</div>
